<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      title='合同订单'
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      :fullscreen='$isMobile'
      max-width='850'
    >
      <template v-slot:content>
         <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select-search hide-details outlined label="客户名称" @on-change='changeCustomer' path='customer/customers' :readonly="isRelation || isEdit || (form.customerId !== undefined && isEdit)" return-object :rules="required" v-model='form.customerId'></v-select-search>
              </v-col>
            </v-row>

            <v-row>
              <v-col :cols="bookkeeping ? 8 : 8">
                <v-select-search :readonly="isEdit" outlined hide-details label="产品名称" @on-change='changeProd' path='product/info/products' return-object :rules="required" v-model='form.product'>
                  <template v-slot:prepend-item>
                  </template>
                </v-select-search>
              </v-col>
              <v-col :cols="bookkeeping ? 2 : 4">
                <v-select
                  :items="yearItems"
                  label="年度"
                  v-model="form.year"
                  hide-details='auto'
                  outlined
                  item-text='label'
                  :rules="required"
                ></v-select>
              </v-col>
              <v-col cols="2" v-if="bookkeeping">
                <v-select
                  :items="monthItems"
                  label="起始月份"
                  v-model="form.month"
                  hide-details='auto'
                  outlined
                  item-text='label'
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>

            <!-- 代账扩展服务-->
            <v-row v-if="bookkeeping">
              <v-col cols="12">
                <v-select
                    :readonly='isPassAndEdit'
                    v-model="form.bookkeepingList"
                    :items="bookkeepingItems"
                    label="增值服务"
                    multiple
                    item-text='name'
                    item-value='id'
                    outlined
                    hide-details='auto'
                    @change="changeBookkeeping"
                  >
                  <template v-slot:selection="{ item }">
                    <v-chip>
                      <span>{{ item.name }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row v-if="highTechSubsidy">
              <v-col cols="12">
                <v-select
                    :readonly='isPassAndEdit'
                    v-model="form.bookkeepingList"
                    :items="highTechSubsidyItems"
                    label="附加服务"
                    item-text='name'
                    item-value='id'
                    outlined
                    hide-details='auto'
                    clearable
                    @change="changeHighTechSubsidy"
                  >
                </v-select>
              </v-col>
            </v-row>

             <v-row>
              <v-col cols="12" md="3">
                <v-text-field label="定价金额"  readonly hide-details='auto' outlined :rules="number" v-model="form.unitPrice"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field label="签单单价" :readonly='isPassAndEdit' hide-details='auto' @input='countPrice' outlined :rules="number" v-model="form.signUnitPrice"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field label="合同收费比例" :readonly='isPassAndEdit' @input='countPrice' hide-details='auto' outlined :rules="number" v-model="form.chargeRatio"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field hide-details='auto' :readonly='isPassAndEdit' :label="bookkeeping ? '服务时长(多少个月)' : '签订数量'" @input='countPrice'  outlined :rules="number" v-model="form.productNumber"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-user-select :show-user='2' :disabled="$store.state.userInfo.accountType === 3" outlined hide-details='auto' :rules="array" label="签订人选择" v-model='form.signUserList'></v-user-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="合同编号"
                  readonly
                  hide-details='auto'
                  outlined
                  :rules="required"
                  v-model="form.serialNumber">
                  <!-- <template v-slot:append>
                    <v-btn fab small :disabled="isEdit || isRelation" :loading='serLoading' color="primary" @click='serialNumber' class="mt-n2 mr-n2">
                      <v-icon dark>mdi-refresh</v-icon>
                    </v-btn>
                  </template> -->
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="contractSignItems"
                  label="签订单位"
                  v-model="form.signId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>

             <v-row v-if="form.signId === 101">
              <v-col cols="12">
                <v-text-field label="渠道名称" :rules="required" hide-details='auto' outlined v-model="form.channelName"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-user-select :show-user='2' :disabled="$store.state.userInfo.accountType === 3" outlined hide-details='auto' :rules="array" label="负责人选择" v-model='form.contactsPersonList'></v-user-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-user-select :show-user='2' :disabled="$store.state.userInfo.accountType === 3" outlined hide-details='auto'  label="协同人选择" v-model='form.assistPersonList'></v-user-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <base-material-date
                  ref='date'
                  :rules="required"
                   hide-details='auto'
                   outlined
                   label='签订时间'
                   clear-icon="mdi-close-circle-outline"
                   v-model='form.signTimeStr'
                 >
                 </base-material-date>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="contractTypeItems"
                  label="合同类型"
                  v-model="form.typeId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>

              <!-- 1. 不是空白合同，2未上传过电子合同 且不是空白合同-->
             <v-row v-if="(form.typeId !== $constants.contractType.NO_CONTRACT)">
                <v-col>
                  <file-upload
                    label="合同扫描件上传(请将文件名称重命名为合同编号)"
                    :rules="isPassAndEdit ? [] : required"
                    outlined
                    prepend-icon=''
                    accept=".pdf"
                    :bucket='bucket'
                    @on-file='onFileName'
                    :file-name='form.serialNumber'
                    :lazy='false'
                    hide-details='auto'
                  />
                </v-col>
              </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="居间人姓名" hide-details='auto' :rules="required" outlined v-model="form.mediatorName"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="居间人费用" :readonly='isPassAndEdit'  @input='countPrice' hide-details='auto' :rules="number" outlined v-model="form.mediatorPrice"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="contractStateItems"
                  label="合同状态"
                  v-model="form.stateId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="签单总金额" :readonly='isPassAndEdit' hide-details='auto' outlined :rules="number" v-model="form.signPrice"></v-text-field>
              </v-col>
            </v-row>

            <v-row>

              <v-col cols="12" md="6">
                <v-text-field label="其他费用(知识产权官费或其他硬性成本)" :readonly='isPassAndEdit' @input='countPrice' hide-details='auto' outlined :rules="number" v-model="form.otherPrice"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="产品绩效" :readonly='isPassAndEdit' hide-details='auto' :rules="number" outlined v-model="form.profitPrice"></v-text-field>
              </v-col>
            </v-row>

            <v-row>

              <v-col cols="12" md="4">
                <v-select
                  :items="userLevelItems"
                  label="人员级别"
                  v-model="form.levelId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  return-object
                  :rules="required"
                  @change='changeLevel'
                  :readonly='isPassAndEdit'
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field label="提成比例(百分制)" readonly suffix="%" hide-details='auto' :rules="number" outlined v-model="form.commissionRatio"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="提成总金额" readonly hide-details='auto' outlined :rules="number" v-model="form.ratioPrice"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field label="特殊情况备注" hide-details='auto' outlined v-model="form.remark"></v-text-field>
              </v-col>
            </v-row>

            <v-card class="mt-3" v-if="!isPassAndEdit" outlined>
              <v-card-title>
                回款单(剩余{{surplusMoney}})
                <v-spacer></v-spacer>
                <v-card-actions v-if="form.signPrice > 0 && form.levelId !== '' && surplusMoney > 0 && form.returnedMoneys.length == 0">
                  <v-btn fab x-small color="primary" @click='addReturn(null)'>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <div class="pd-c-10" v-for="(item, idx) in form.returnedMoneys" :key="idx">
                <v-card class="px-3">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field label="回款编号" readonly :value="item.returnNumber" hide-details='auto' outlined v-model="form.returnedMoneys[idx].returnNumber"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field label="回款金额" readonly :value="item.money" hide-details='auto' outlined v-model="form.returnedMoneys[idx].money"></v-text-field>
                    </v-col>
                     <v-col cols="12" md="3">
                      <v-text-field label="本次提成" readonly :value="item.ratioPrice" hide-details='auto' outlined v-model="form.returnedMoneys[idx].ratioPrice"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small text class="text--disabled" @click='deleteReturn(item)'>
                      删除
                    </v-btn>
                    <v-btn small color="warning" @click='addReturn(item)'>
                      编辑
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </v-card>

            <v-card class="mt-3" v-if="!isPassAndEdit" outlined>
              <v-card-title>
                应收款(剩余{{surplusMoney}})
                <v-spacer></v-spacer>
                <v-card-actions v-if="form.signPrice > 0 && surplusMoney > 0">
                  <v-btn fab x-small color="primary" @click='addCollect(null)'>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <div class="pd-c-10" v-for="(item, idx) in form.collectMoneys" :key="idx">
                <v-card class="px-3" >
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field label="回款编号" readonly :value="item.collectNumber" hide-details='auto' outlined v-model="form.collectMoneys[idx].collectNumber"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field label="回款金额" readonly :value="item.money" hide-details='auto' outlined v-model="form.collectMoneys[idx].money"></v-text-field>
                    </v-col>
                     <v-col cols="12" md="3">
                       <v-select
                          :items="returnedMoneyTypeItems"
                          label="回款类型"
                          v-model="form.collectMoneys[idx].returnTypeId"
                          hide-details='auto'
                          outlined
                          item-text='name'
                          item-value="id"
                          readonly
                        ></v-select>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small text class="text--disabled" @click='deleteCollect(item)'>
                      删除
                    </v-btn>
                    <v-btn small color="warning" @click='addCollect(item)'>
                      编辑
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </v-card>

          </v-form>
          <v-card-actions class="mt-3">
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" class="px-2" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>

        </v-card>
      </template>
    </base-material-dialog>
    <v-snackbar v-model="tip.show" timeout='3000' centered rounded="pill" color="warning"><v-icon>mdi-alert-circle-outline</v-icon>&nbsp;
      <span class="font-weight-bold">{{ tip.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text fab v-bind="attrs" small @click="tip.show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
    <return-add :item='returnAddModal' :surplus-money.sync='surplusMoney' @on-submit='subReturnMoney'></return-add>
    <collect-add :item='collectAddModal' :surplus-money.sync='surplusMoney' @on-submit='subCollectMoney'></collect-add>
  </v-container>
</template>

<script>
  import { isEmpty } from '@/utils/stringUtil.js'
  import { selectNextYear, selectMonthData } from '@/utils/tool.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { serialNumber } from '@/api/data.js'
  import { save } from '@/api/contract/index.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import VUserSelect from '@/components/select/v-user-select.vue'
  import FileUpload from '@/components/oss/Index.vue'
  import ReturnAdd from '../../returned/components/Add.vue'
  import CollectAdd from '../../collect/components/Add.vue'

  export default {
    name: 'ContractEdit',
    components: {
      VSelectSearch,
      VUserSelect,
      ReturnAdd,
      CollectAdd,
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          customerId: '',
          customerName: '',
          relation: false
        })
      }
    },
    data() {
      return {
        returnAddModal: {
          form: {}, data: [], show: false, type: 2
        },
        collectAddModal: {
          form: {}, data: [], show: false, type: 2
        },
        loading: false,
        serLoading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        maxMoney: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && value <= this.surplusMoney) || `金额必填且不得超过${this.surplusMoney}`,
        ],
        number: [
          value => /^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) || '必须输入数字',
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        channelItems: [
          { label: '是', value: 1 },
          { label: '否', value: 2 }
        ],
        unitPrice: 0,
        signUnitPrice: 0,
        bookkeeping: false,
        highTechSubsidy: false,
        bucket: 'yd-contract',
        tip: { show: false, text: '' },
        customerName: '',
        surplusMoney: 0,
        yearItems: selectNextYear(),
        monthItems: selectMonthData(),
        productItems: [],
        contractSignItems: [],
        contractStateItems: [],
        contractTypeItems: [],
        userLevelItems: [],
        bookkeepingItems: [],
        highTechSubsidyItems: [],
        contractPayTypeItems: [],
        contractBackTypeItems: [],
        contractBackStateItems: [],
        returnedMoneyTypeItems: [],
        form: {
          id: '',
          customerId: '',
          signId: '',
          serialNumber: '',
          signUser: '',
          signPrice: '',
          signUnitPrice: '',
          signUserList: [],
          contactsPersons: '',
          contactsPersonList: [],
          assistPersons: '',
          assistPersonList: [],
          bookkeeping: '',
          bookkeepingList: [],
          productId: '',
          productNumber: '',
          product: {},
          signTime: '',
          signTimeStr: '',
          typeId: '',
          stateId: this.$constants.ContractState.SIGN_ID,
          year: '',
          month: '',
          unitPrice: '',
          chargeRatio: 0,
          mediatorName: '无',
          mediatorPrice: 0,
          otherPrice: 0,
          profitPrice: '',
          levelId: '',
          level: {},
          commissionRatio: '',
          ratioPrice: '',
          channelName: '',
          version: '',
          remark: '',
          returnedMoneys: [],
          collectMoneys: [],
          fileName: ''
        },
        deForm: {
          id: '',
          customerId: '',
          signId: '',
          serialNumber: '',
          signUser: '',
          signPrice: '',
          signUnitPrice: '',
          signUserList: [],
          contactsPersons: '',
          contactsPersonList: [],
          assistPersons: '',
          assistPersonList: [],
          bookkeeping: '',
          bookkeepingList: [],
          productId: '',
          productNumber: '',
          product: {},
          signTime: '',
          signTimeStr: '',
          typeId: '',
          stateId: this.$constants.ContractState.SIGN_ID,
          year: '',
          month: '',
          unitPrice: '',
          chargeRatio: 0,
          mediatorName: '无',
          mediatorPrice: 0,
          otherPrice: 0,
          profitPrice: '',
          levelId: '',
          level: {},
          commissionRatio: '',
          ratioPrice: '',
          channelName: '',
          version: '',
          remark: '',
          returnedMoneys: [],
          collectMoneys: [],
          fileName: '',
          officialPrice: ''
        }
      }
    },
    methods: {
      save () {
        this.builSubForm()
        if (this.surplusMoney !== 0) {
          this.tip = { show: true, text: '请完善应收计划！' }
          return false
        }
        if (this.form.typeId !== this.$constants.contractType.NO_CONTRACT && !this.form.fileName) {
          this.tip = { show: true, text: '请上传合同扫描件！' }
          return false
        }
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      onFileName (fileName) {
        this.form.fileName = `${this.bucket}/${fileName}`
      },
      addCollect (item) {
        this.collectAddModal = {
          show: true,
          contractId: this.form.id,
          customerName: this.customerName,
          data: item,
          type: 2
        }
        this.countSurplusMoney(item)
      },
      addReturn (item) {
        this.returnAddModal = {
          show: true,
          contractId: this.form.id,
          customerName: this.customerName,
          data: item,
          type: 2
        }
        this.countSurplusMoney(item)
      },
      deleteReturn (item) {
        this.form.returnedMoneys.splice(this.form.returnedMoneys.indexOf(this.form.returnedMoneys.find((element) => element.returnNumber === item.returnNumber)), 1)
        this.countSurplusMoney(null)
      },
      deleteCollect (item) {
        this.form.collectMoneys.splice(this.form.collectMoneys.indexOf(this.form.collectMoneys.find((element) => element.collectNumber === item.collectNumber)), 1)
        this.countSurplusMoney(null)
      },
      subReturnMoney (item) {
        if (this.form.otherPrice > 0 || this.form.mediatorPrice > 0) {
          // 本次居间费
          item.mediatorPrice = this.form.mediatorPrice / this.form.signPrice * item.money
          item.ratioPrice = ((item.money - this.form.otherPrice - item.mediatorPrice) * (this.form.commissionRatio / 100)).toFixed(2)
        } else {
          item.ratioPrice = (item.money * (this.form.commissionRatio / 100)).toFixed(2)
        }
        if (this.form.returnedMoneys.find((element) => element.returnNumber === item.returnNumber)) {
          this.form.returnedMoneys.splice(this.form.returnedMoneys.indexOf(this.form.returnedMoneys.find((element) => element.returnNumber === item.returnNumber)), 1, item)
        } else {
          this.form.returnedMoneys.push(item)
        }
        this.countSurplusMoney(null)
      },
      subCollectMoney (item) {
        if (this.form.collectMoneys.find((element) => element.collectNumber === item.collectNumber)) {
          this.form.collectMoneys.splice(this.form.collectMoneys.indexOf(this.form.collectMoneys.find((element) => element.collectNumber === item.collectNumber)), 1, item)
        } else {
          this.form.collectMoneys.push(item)
        }
        this.countSurplusMoney(null)
      },
      builSubForm () {
        this.form.signTime = new Date(this.form.signTimeStr).getTime() / 1000
        this.form.signUser = JSON.stringify(this.form.signUserList)
        this.form.contactsPersons = JSON.stringify(this.form.contactsPersonList)
        this.form.assistPersons = JSON.stringify(this.form.assistPersonList)
        this.form.bookkeeping = JSON.stringify(this.form.bookkeepingList)
      },
      serialNumber () {
        this.serLoading = true
        serialNumber().then(res => {
          if (res.status === 200) {
            this.form.serialNumber = `YD.${res.data}.001`
          }
          this.serLoading = false
        })
      },
      changeCustomer (item) {
        this.form.customerId = isEmpty(item) ? '' : item.id
        this.customerName = isEmpty(item) ? '' : item.name
      },
      changeProd (item) {
        this.form.productId = isEmpty(item) ? '' : item.id
        this.form.unitPrice = this.form.product ? Number(this.form.product.price) : 0
        this.form.signUnitPrice = this.form.product ? Number(this.form.product.price) : 0
        this.form.officialPrice = this.form.product ? Number(this.form.product.officialPrice) : 0
        this.countPrice()
        // 代账附加服务
        if (this.$constants.ProductType.Bookkeeping.indexOf(this.form.productId) !== -1) {
          this.unitPrice = this.form.unitPrice
          this.signUnitPrice = this.form.signUnitPrice
          this.bookkeeping = true
        } else {
          this.bookkeeping = false
          this.form.bookkeepingList = []
        }
        // 高新/研补附加服务
        if (
            this.$constants.ProductType.AuditReport.indexOf(this.form.productId) !== -1 ||
            this.$constants.ProductType.HighTech.indexOf(this.form.productId) !== -1 ||
            this.$constants.ProductType.RDSubsidy.indexOf(this.form.productId) !== -1
          ) {
          this.unitPrice = this.form.unitPrice
          this.signUnitPrice = this.form.signUnitPrice
          this.highTechSubsidy = true
        } else {
          this.highTechSubsidy = false
        }
      },
      changeHighTechSubsidy (id) {
        let bkMoney = 0.0
        this.form.unitPrice = this.unitPrice
        this.form.signUnitPrice = this.signUnitPrice
        this.highTechSubsidyItems.forEach(bk => {
          if (bk.id === id) {
              bkMoney += bk.value
            }
        })
        this.form.unitPrice += this.unitPrice === 0 ? 0 : bkMoney
        this.form.signUnitPrice += this.unitPrice === 0 ? 0 : bkMoney
      },
      changeBookkeeping (items) {
        let bkMoney = 0.0
        this.form.unitPrice = this.unitPrice
        this.form.signUnitPrice = this.signUnitPrice
        this.bookkeepingItems.forEach(bk => {
          items.forEach(book => {
            if (bk.id === book) {
              bkMoney += bk.value
            }
          })
        })
        this.form.unitPrice += bkMoney
        this.form.signUnitPrice += bkMoney
      },
      changeLevel (item) {
        this.form.levelId = isEmpty(item) ? '' : item.id
        this.form.commissionRatio = isEmpty(item) ? 0 : Number(item.value)
        this.countPrice()
        this.form.returnedMoneys.forEach(val => {
          val.ratioPrice = (val.money * (this.form.commissionRatio / 100)).toFixed(2)
        })
      },
      countPrice () {
        this.form.otherPrice = Number(this.form.officialPrice) > 0 ? Number(this.form.officialPrice) * this.form.productNumber : this.form.otherPrice
        this.form.signPrice = Number(this.form.signUnitPrice) * this.form.productNumber
        this.form.profitPrice = (Number(this.form.signPrice) - Number(this.form.mediatorPrice) - Number(this.form.otherPrice) + Number(this.form.chargeRatio)).toFixed(2)
        this.form.ratioPrice = (this.form.profitPrice * (this.form.commissionRatio / 100)).toFixed(2)
        this.countSurplusMoney(null)
      },
      countSurplusMoney (item) {
        let money = 0
        this.form.returnedMoneys.forEach(val => {
          if (item && item.returnNumber) {
            if (item.returnNumber !== val.returnNumber) {
              money = Number(money) + Number(val.money)
            }
          } else {
            money = Number(money) + Number(val.money)
          }
        })
        this.form.collectMoneys.forEach(val => {
          if (item && item.collectNumber) {
            if (item.collectNumber !== val.collectNumber) {
              money = Number(money) + Number(val.money)
            }
          } else {
            money = Number(money) + Number(val.money)
          }
        })
        this.surplusMoney = Number(this.form.signPrice) - Number(money)
        if (!isEmpty(this.$refs.form)) this.$refs.form.resetValidation()
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
            this.bookkeeping = this.$constants.ProductType.Bookkeeping.indexOf(this.form.productId) !== -1
          } else {
            this.form.id = ''
            this.form.signUserList = [
              {
                id: this.$store.state.userInfo.id,
                name: this.$store.state.userInfo.name,
                uid: this.$store.state.userInfo.userId
              }
            ]
            this.form.contactsPersonList = this.form.signUserList
            if (this.isRelation) {
              const hisNumber = this.item.data.serialNumber
              const relationNum = this.item.data.relationNum >= 10 ? `0${this.item.data.relationNum + 1}` : `00${this.item.data.relationNum + 1}`
              this.form.serialNumber = `${hisNumber.substr(0, hisNumber.lastIndexOf('.'))}.${relationNum}`
              this.form.customerId = this.item.data.customerId
              this.customerName = this.item.data.customer.name
              this.form.fileName = this.item.data.fileName
            } else {
              this.serialNumber()
              this.form.customerId = this.item.customerId
              this.customerName = this.item.customerName
            }
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.deForm))
          if (!isEmpty(this.$refs.form)) this.$refs.form.resetValidation()
        }
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.contractSignPid,
              this.$constants.contractStatePid,
              this.$constants.contractTypePid,
              this.$constants.userLevelPid,
              this.$constants.returnedMoneyTypePid,
              this.$constants.agentBookkeepingServicePid,
              this.$constants.highTechRDSubsidyPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
              if (this_.$constants.contractSignPid === result.id) {
                  this_.contractSignItems = result.data
              } else if (this_.$constants.contractStatePid === result.id) {
                this_.contractStateItems = result.data
              } else if (this_.$constants.contractTypePid === result.id) {
                this_.contractTypeItems = result.data
              } else if (this_.$constants.userLevelPid === result.id) {
                if (this.$store.state.userInfo.level && this.$store.state.userInfo.level.id) {
                  this_.userLevelItems = result.data.filter((i) => Number(i.value) <= Number(this.$store.state.userInfo.level.value))
                }
              } else if (this_.$constants.returnedMoneyTypePid === result.id) {
                  this_.returnedMoneyTypeItems = result.data
              } else if (this_.$constants.agentBookkeepingServicePid === result.id) {
                this_.bookkeepingItems = result.data
              } else if (this_.$constants.highTechRDSubsidyPid === result.id) {
                this_.highTechSubsidyItems = result.data
              }
           })
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null && !this.item.relation
      },
      isRelation () {
        return this.item.relation
      },
      isPassAndEdit () {
        return this.item.data !== undefined && this.item.data !== null && this.item.data.order.auditStatus === 1 && !this.item.relation
      }
    },
    created () {
      this.getTypes()
    }
  }
</script>

<style lang="sass" scoped>
</style>
